import _ from 'lodash';
import * as types from '../constants/ActionTypes';

const initialState = {
	list: null,
	pagination: null,
	isFetchingList: false,
	error: null,
};

export default function plans (state = initialState, action) {
	switch (action.type) {
		case types.REQUEST_PLAN_LIST:
			return {
				...state,
				list: null,
				isFetchingList: true,
				error: null
			};

		case types.RECEIVE_PLAN_LIST:
			return {
				...state,
				list: action.response.results,
				pagination: action.response.pagination,
				isFetchingList: false,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/plans.js